import { SxProps, Theme } from '@mui/material';

export const styles: Record<'row', SxProps<Theme>> = {
  row: {
    backgroundColor: (theme) => theme.palette.gray[50],
    borderRadius: '10px',
    padding: (theme) => theme.spacing(2),
  },
};
